// @ts-nocheck
import React, {useEffect, useState} from "react";
import KeycloakService from "../service/keycloak";
import {Spin} from "antd";

interface Props {
    children?: any
}

const KeycloakProvider = ({children}: Props) => {
    const [loading, setLoading] = useState(true);

    const keycloak = KeycloakService.getInstance();

    const _localLogout = () => {
        window.sessionStorage.removeItem('token');
    }

    const _localLogin = () => {
        // set token to session storage for apollo
        window.sessionStorage.setItem('token',keycloak.token)
    }

    const _refreshToken = () => {
        window.sessionStorage.setItem('token',keycloak.token)
    }

    const _getNewKeycloakToken = () => {
        keycloak.updateToken(60).then((refreshed: any)=>{
            if (refreshed){
                _refreshToken();
                console.log('Token refreshed. New token: ', keycloak.token);
            }else {
                console.info('Token not refreshed: ' + new Date());
            }
        }).catch(() => {
            console.error('Failed to refresh token: ' + new Date());
        });
    }

    useEffect((): any => {
        if (keycloak && loading) {
            console.log('KeycloakService init: ...')
            KeycloakService.init()
                .then((authenticated?: any) => {
                    console.log('authenticated: ', authenticated)

                    if (authenticated) {
                        _localLogin()
                    } else {
                        _localLogout()
                    }
                    return setLoading(false);
                })
                .catch((__err: any) => {
                    console.log('auth error')
                    _localLogout()
                    return setLoading(false);
                });
        } else {
            return setLoading(false);
        }
    }, []) // eslint-disable-line react-hooks/exhaustive-deps

    keycloak.onAuthLogout = _localLogout;
    keycloak.onTokenExpired = _getNewKeycloakToken;

    if (loading) {
        return <div style={{textAlign: "center"}}>
            <Spin/>
        </div>;
    }

    return children;
}

export default KeycloakProvider;
